module.exports = __webpack_public_path__ + "img/WHATNOT.25c7388b.png";